import {bunkSleepCapacity} from './planned-bunk-choices';

export type SleepCapacity = {goal:number;capacity:number;shortfall:number;goalLabel:string};
/** Six is the minimum requested by the existing “6+” quick-start option. */
export function savedSleepGoal(answers:unknown):number|undefined {
  if(!answers||typeof answers!=='object')return undefined;
  const {sleepers,answeredThrough}=answers as {sleepers?:unknown;answeredThrough?:unknown};
  // An unanswered default of two is not a customer goal. Legacy completed answers
  // have no answeredThrough field; keep those saved goals readable.
  if(answeredThrough!==undefined&&(typeof answeredThrough!=='number'||answeredThrough<2))return undefined;
  return typeof sleepers==='number'&&Number.isInteger(sleepers)&&sleepers>=2&&sleepers<=6?sleepers:undefined;
}
export function sleepCapacity(choices:number[],goal?:number):SleepCapacity|undefined {
  if(goal===undefined||!Number.isInteger(goal)||goal<2||goal>6)return undefined;
  const capacity=bunkSleepCapacity(choices);
  return {goal,capacity,shortfall:Math.max(0,goal-capacity),goalLabel:goal===6?'6+':String(goal)};
}
